export function isSendableMessage(msg) {
    return msg !== undefined && msg !== null && 'sendingStatus' in msg;
}
export function isMyMessage(msg, currentUserId = '##__USER_ID_IS_NOT_PROVIDED__##') {
    var _a;
    if (!isSendableMessage(msg))
        return false;
    return ((_a = msg.sender) === null || _a === void 0 ? void 0 : _a.userId) === currentUserId;
}
export function isNewMessage(msg, currentUserId) {
    const myMessage = isMyMessage(msg, currentUserId);
    if (myMessage)
        return false;
    if (msg.isAdminMessage())
        return false;
    return msg.updatedAt === 0;
}
export function getMessageUniqId(msg) {
    if ('sendingStatus' in msg) {
        if (msg.sendingStatus === 'succeeded')
            return String(msg.messageId);
        return msg.reqId;
    }
    return String(msg.messageId);
}
